module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_5010.77cf34ba.png";